// Donor-scope communications inbox API helper — CHG-1521 wave 3.
//
// Backend: portal.py canonical GET /api/v1/my-giving/communications.
// Returns {data, pagination:{page, per_page, total, total_pages}} with
// each entry: {id, sent_at, template_display_name, channel, status,
// subject}. status is normalized server-side to "sent" | "pending".

import { apiClient } from "./client";

export interface MyCommunication {
  id: string;
  sent_at: string | null;
  template_display_name: string;
  channel: string;
  /** "sent" → Delivered; "pending" → Pending */
  status: string;
  subject: string | null;
}

export interface MyCommunicationsEnvelope {
  data: MyCommunication[];
  pagination: {
    page: number;
    per_page: number;
    total: number;
    total_pages: number;
  };
}

export interface ListMyCommunicationsParams {
  page?: number;
  pageSize?: number;
  sortField?: string;
  sortDirection?: "asc" | "desc";
  search?: string;
}

export async function listMyCommunications(
  params: ListMyCommunicationsParams = {},
): Promise<{ items: MyCommunication[]; total: number }> {
  const r = await apiClient().get<MyCommunicationsEnvelope>(
    "/my-giving/communications",
    {
      params: {
        page: (params.page ?? 0) + 1,
        per_page: params.pageSize ?? 25,
      },
    },
  );
  return { items: r.data.data, total: r.data.pagination.total };
}

export const meCommunicationsApi = {
  listMyCommunications,
};
